/**
 * Terms of Service Page
 * Static legal page. Plain-English terms covering accounts, user content,
 * acceptable use, the weekly contest, liability and termination.
 */

import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfServicePage = () => (
  <div className="container legal-page" style={{ maxWidth: 720 }}>
    <h1>Terms of Service</h1>
    <p><em>Effective date: 2 July 2026</em></p>

    <p>
      Welcome to WriteFlow, a creative writing platform built around a daily prompt.
      By creating an account or using WriteFlow you agree to these terms. If you do not
      agree, please do not use the service.
    </p>

    <h2>1. Who can use WriteFlow</h2>
    <p>
      You must be at least 13 years old to use WriteFlow. You are responsible for your
      account: keep your password safe and give us accurate information.
    </p>

    <h2>2. Your writing stays yours</h2>
    <p>
      You own everything you write on WriteFlow. By posting, you grant WriteFlow a
      non-exclusive, worldwide licence to host, display and share your content as part
      of operating the platform — for example showing your post in feeds, on your
      profile, in link previews when someone shares it, and in the contest leaderboard.
      Delete a post (or your account) and this licence ends for that content.
    </p>

    <h2>3. Acceptable use</h2>
    <p>Don't use WriteFlow to:</p>
    <ul>
      <li>post content that is unlawful, hateful, harassing, or sexualises minors;</li>
      <li>impersonate others or misrepresent who you are;</li>
      <li>spam, scrape at scale, or run automated accounts without our permission;</li>
      <li>interfere with the service or other people's use of it.</li>
    </ul>
    <p>
      We may remove content, dismiss or act on reports, and suspend or ban accounts
      that break these rules. Serious or repeated breaches end your access permanently.
    </p>

    <h2>4. The weekly contest</h2>
    <p>
      Responding to any daily prompt automatically enters that week's contest
      (Monday to Monday, UK time). Entry is free. One winner is chosen each week on
      merit — community likes inform, but do not decide, the result. Entrants must be
      18 or older, or have a parent or guardian's consent. The prize (where offered) is
      shown on the <Link to="/contest">contest page</Link> and is paid directly by
      WriteFlow. Our decision on the winner is final.
    </p>

    <h2>5. The service is provided as-is</h2>
    <p>
      WriteFlow is provided without warranties of any kind. We work to keep it
      available and your writing safe, but we cannot promise uninterrupted service and
      we are not liable for indirect losses arising from your use of the platform.
      Nothing in these terms limits liability that cannot be limited under law.
    </p>

    <h2>6. Ending your account</h2>
    <p>
      You can delete your account at any time in Settings — this permanently deletes
      your posts. We may suspend or terminate accounts that breach these terms.
    </p>

    <h2>7. Changes and contact</h2>
    <p>
      We may update these terms as WriteFlow evolves; material changes will be flagged
      on the site. These terms are governed by the laws of England and Wales. Questions?
      Use the in-app feedback form.
    </p>

    <p>
      See also our <Link to="/privacy">Privacy Policy</Link>.
    </p>
  </div>
);

export default TermsOfServicePage;
